// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__ERAAk","author-portrait":"Quote_author-portrait__aJk6B","text":"Quote_text__JdogR","author":"Quote_author__7kC5d"};